import classnames from 'classnames';
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

const SkillItem = props => {
  const { name, isHeroSkill } = props;
  return <div className={classnames('profile-form__skill', { 'profile-form__tag-checked': isHeroSkill })}>{name}</div>;
};

const SkillPicker = props => {
  const { question, allSkills, noSpecificSkills } = props;
  return (
    <div className="profile-form__picker">
      <div className="profile-form__label">{_.capitalize(question)}</div>
      <div className="profile-form__tags">
        {_.size(allSkills) > 0 ? (
          allSkills.map(skill => <SkillItem id={skill.id} key={skill.id} name={skill.name} isHeroSkill={skill.is_hero_skill} />)
        ) : (
          <SkillItem id={1} key={1} name={noSpecificSkills} isHeroSkill />
        )}
      </div>
    </div>
  );
};

SkillPicker.propTypes = {
  allSkills: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  question: PropTypes.string,
  noSpecificSkills: PropTypes.string,
};
SkillPicker.defaultProps = {
  allSkills: [],
  question: '',
  noSpecificSkills: '',
};

SkillItem.propTypes = {
  name: PropTypes.string,
  isHeroSkill: PropTypes.bool,
};
SkillItem.defaultProps = {
  name: null,
  isHeroSkill: false,
};

export default SkillPicker;
